import React, { useMemo } from 'react';
import { CMBS_ID } from '@/creditflowresearch/application/Deal/constants';
import DealDetails from './DealDetails';
import TrancheTable from './Tranches/TrancheTable';
import IDeal from '@/creditflowresearch/domain/vo/IDeal';
import IRatingsMapping from '@/creditflowresearch/domain/vo/IRatingsMapping';
import { getSortedTranches } from '@/creditflowresearch/ui/components/deals/helpers';

interface IDealBodyProps {
  deal: IDeal,
  showDealDetailsByDefault: boolean,
  ratingsMapping: IRatingsMapping,
  // TODO: remove when the European market opening period ends
  isRestricted?: boolean,
}

const DealBody = ({
  deal,
  showDealDetailsByDefault,
  ratingsMapping,
  // TODO: remove when the European market opening period ends
  isRestricted = false,
}: IDealBodyProps) => {
  const isDealCmbs = deal.sector && deal.sector.id === CMBS_ID;

  const sortedTranches = useMemo(
    () => getSortedTranches(deal.tranches),
    [deal.tranches],
  );

  return (
    <>
      { sortedTranches.length > 0 && (
        <TrancheTable
          dealType={ deal.dealType }
          dealStatus={ deal.status }
          tranches={ sortedTranches }
          isDealCmbs={ isDealCmbs }
          ratingsMapping={ ratingsMapping }
        />
      ) }

      <DealDetails
        deal={ deal }
        showDealDetailsByDefault={ showDealDetailsByDefault }
        isRestricted={ isRestricted }
      />
    </>
  );
};

export default React.memo(DealBody);
